import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
       // console.log("GGg",localStorage.getItem('token'));
        if (localStorage.getItem('token')) {
            return true;
        }
        this.router.navigate(['/ecademic/login']);
        return false;
    }
}